function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { Children, isValidElement, useMemo, createElement, cloneElement } from "react";
const RenderIfChildExists = (props)=>{
    const { component , children  } = props, propsToPass = _objectWithoutProperties(props, [
        "component",
        "children"
    ]);
    const childExists = useMemo(()=>{
        return Children.toArray(children).some((child)=>/*#__PURE__*/ isValidElement(child));
    }, [
        children
    ]);
    if (!childExists) return null;
    if (/*#__PURE__*/ isValidElement(component)) return /*#__PURE__*/ cloneElement(component, propsToPass, children);
    return /*#__PURE__*/ createElement(component, propsToPass, children);
};
export default RenderIfChildExists;
